<template>
    <div>
        <h3 class="mb-3 text-[13px] font-medium text-theme-text">
            {{ localizations[lang].readingModes }}
        </h3>
        <div class="flex flex-wrap gap-2">
            <SettingsButton
                v-for="mode in options"
                :key="mode.value"
                variant="pill"
                :is-active="ui.themeSelected === mode.value"
                @click="selectMode(mode.value)"
            >
                {{ localizations[lang].tooltips[mode.labelKey] }}
            </SettingsButton>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SettingsButton from './SettingsButton.vue';

const READING_MODE_OPTIONS = [
    { value: 'cream', labelKey: 'themeCream' },
    { value: 'sepia', labelKey: 'themeSepia' },
    { value: 'cyan', labelKey: 'themeCyan' },
    { value: 'high-contrast-light', labelKey: 'themeHighContrast' },
    { value: 'high-contrast-dark', labelKey: 'themeHighContrastDark' },
];

export default {
    name: 'ReadingModeSelector',
    components: {
        SettingsButton,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),

        options() {
            return READING_MODE_OPTIONS;
        },
    },
    methods: {
        ...mapActions(['setTheme', 'updateUserSettings']),

        selectMode(theme) {
            if (this.ui.themeSelected === theme) {
                const baseTheme = this.ui.baseTheme;
                this.setTheme({ theme: baseTheme });
                this.updateUserSettings({ theme: baseTheme });
            } else {
                this.setTheme({ theme });
                this.updateUserSettings({ theme });
            }
        },
    },
};
</script>
